import LookupFieldComponent from './lookup-field-component';

/***
 * a field with a small input box that will automatically check against the keys of an object that is passed in
 * and display the resulting value next to the input. It will throw a validation error if the entered value does not
 * match any of the values of the passed-in object.
 */
const lookupField = angular
    .module('FacilityData.ClientEdit.FormFields.LookupField', [])
    .component('lookupField', LookupFieldComponent)
    .name;

export default lookupField;


// WEBPACK FOOTER //
// ./app/common/form-fields/lookup-field/lookup-field.js